import {blueColor} from '../../cmsMainStyle'

const fileMangerNavStyle = theme => ({
	root: {
		marginLeft: 20,

		// fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
		// fontWeight: "800",
		// fontSize: "15px",
		// paddingLeft: 50,

		// color: blueColor[12],
	},

	font: {
		fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
		// fontWeight: "800",
		fontWeight: 'Normal',
		//  fontWeight: 'Bold',
		fontSize: "13px",
		 color: blueColor[8],
		//  color: grayColor[10]
		
	}

})


export default fileMangerNavStyle